import { useIsMobile } from '~/context/common/DeviceContext';
import {
  Card,
  CardImageSection,
  CardInfoSection
} from '../../OrderStatusCards/OrderStatusCards.styles';
import {
  SkeletonImage,
  SkeletonTextLarge,
  SkeletonTextMedium,
  SkeletonTextSmall
} from '../Skeleton.styles';

export default function OrderStatusCardSkeleton() {
  const isMobile = useIsMobile();

  return (
    <Card className="animate-pulse">
      <CardInfoSection>
        <div>
          <SkeletonTextMedium className="mb-12 max-w-[350px]" />
          <SkeletonTextSmall className="mb-4 max-w-[500px]" />
          <SkeletonTextSmall className="max-w-[250px]" />
        </div>
        {!isMobile && (
          <>
            <div>
              <SkeletonTextMedium className="mb-12 max-w-[250px]" />
              <SkeletonTextSmall className="max-w-[300px]" />
            </div>
            <SkeletonTextLarge className="mt-12 m:max-w-[250px]" />
          </>
        )}
      </CardInfoSection>
      <CardImageSection className="w-full ">
        <SkeletonImage />
        {isMobile && (
          <>
            <div className="my-16">
              <SkeletonTextMedium className="mb-8 max-w-[250px]" />
              <SkeletonTextSmall className="max-w-[300px]" />
            </div>
            <SkeletonTextLarge className="mt-12 m:max-w-[250px]" />
          </>
        )}
      </CardImageSection>
    </Card>
  );
}
